import { cn } from '@landler/component-library';
import { TextInput, TextInputProps } from 'component-library/Input/TextInput';

import { FormControl, FormDescription, FormItem, FormLabel, FormMessage, useFormField } from '@/components/Form';

import { useControlsContext } from './Form';

type FormTextInputProps = {
  formName: string;
  label?: string;
  helper?: string;
  styles?: Record<string, string>;
} & TextInputProps;

export const FormTextInput = ({ formName, label, helper, styles, ...props }: FormTextInputProps) => {
  const { setValue, watch } = useControlsContext();
  const { error } = useFormField();

  const selectedFormValue = watch(formName);

  const handleValueChange = (value: string | null) => {
    setValue(formName, value);
  };

  return (
    <FormItem className={cn('flex flex-col gap-1 w-full', styles?.root)}>
      <FormLabel
        className={cn(
          'typography-overline text-text-secondary',
          {
            'text-error': error,
          },
          styles?.label,
        )}
      >
        {label ?? ''}
      </FormLabel>
      <FormControl>
        <TextInput
          className={cn(styles?.input)}
          {...props}
          value={selectedFormValue}
          onChange={(e) => handleValueChange(e.target.value)}
        />
      </FormControl>
      <FormMessage className={cn('typography-inputLabel mt-0 text-error', styles?.message)}>
        {error?.message ?? ''}
      </FormMessage>
      <FormDescription className={styles?.description}>{helper ?? ''}</FormDescription>
    </FormItem>
  );
};
